<template lang='pug'>
	span(v-if="p_infoTxt" class="tt-info" 
		v-b-tooltip.focus="{title:p_infoTxt, customClass:'tt-focus'}" href="#" tabindex="0") 
		fa-icon(icon="info-circle")
</template>

<script>
export default {
	name: "kt-tt-info",
	props: {
		p_infoTxt: String,
	},
};
</script>

<style lang="less">
.tt-info {
	outline: none;
	cursor: pointer;
	color: #adb5bd;
	font-size: 0.9em;
	svg {
		margin: 0 0.5em;
		vertical-align: middle;
		transform: translateY(-0.1em);
	}
	&:hover {
		color: #4fa4ff;
	}
}
</style>